<template>
	<transition mode="out-in" name="leftIn">
		<router-view @update_name="update_name"></router-view>
	</transition>
</template>

<script>
	export default {
		name: 'Ligacoes',
		props: ["get"],

		mounted() {
			this.$emit('update:button', {})
			this.$emit('update:pdf', false)
			this.update_name('de ligações')
		},

		beforeRouteUpdate(to, from, next) {
			if ( to.name == "rel_select" ) 
				this.update_name('de ligações')

			next();
		},

		methods: {
			update_name(payload) {
				this.$emit('update:rel_name', payload)
			}
		}
	};
</script>

<style>
</style>